export default {
  isLoggedIn: false,
  user: {
  },
  Aue: {
    selected: {}
  },
  Ods: {
    selected: {}
  },
  CiudadSelected: null,
  imgObjetivoEstrategico: null,
  objetivoEspecifico: {
    name: '',
    id: ''
  },
  nameIndicador: null
};
